import React, { useContext, useEffect, useState } from "react";
import Img from "../Img";
import { classIf, getConfiguration, getCurrencyValue } from "../../data/utils";
import { BetslipContext } from "../../data/betslip/BetslipConf";
import Coupon from "./Coupon";
import BetslipBar from "./BetslipBar";
import Settings from "./Settings";
import AmountBetslipForm from "./AmountBetslipForm";
import PotentialWinBox from "./PotentialWinBox";
import MultiBonus from "./MultiBonus";
import TypeSelector from "./TypeSelector";
import { xs_isMobile } from "../..";
import { getLabel } from "../../InitData";
import BetslipVariationModal from "./BetslipVariationModal";
import BetslipLoader from "../../data/betslip/BetslipLoader";
import WageringSection from "./WageringSection";
import BetslipLoaderWrapper from "./BetslipLoaderWrapper";

function getStyle(toggled) {
    let height = 'auto';

    if (xs_isMobile) {
        if (toggled) {
            try {
                const navBarHeight = document.querySelector('.m_7').getBoundingClientRect().height;
                height = document.querySelector('.m_2').getBoundingClientRect().height - navBarHeight;
            } catch(e) {}
        }
        // return {height: `calc(100dvh - var(--topbar-height) - 48px)`};
        return {height};
    }

    height = '100%';
    const container = document.querySelector('.c_8');
    if (container != null) {
        height = container.getBoundingClientRect().height;
    }
    
    return {maxHeight: height};
}

export default function Betslip() {
    const conf = getConfiguration();
    const betslipContext = useContext(BetslipContext);
    const betslipData = betslipContext.getBetslipData();
	const cartMessage = betslipContext.getCartMessage();
    const couponKey = betslipData?.selectedCoupon;
	const coupon = betslipContext.getCurrentCoupon();
    const toggleSettings = () => betslipContext.toggleBetslipSettings();
    const clearBetslip = () => betslipContext.clearBetslip(0);
    const [toggled, setToggled] = useState(false);
    const toggleBetslip = () => {
        setToggled(!toggled);
        if (toggled) {
            document.body.classList.remove('xs_betslipOpen');
        } else {
            document.body.classList.add('xs_betslipOpen');
        }
    };
	const [betslipVariationModalData, setBetslipVariationModalData] = useState(null);
	
	useEffect(() => {
		window.showBetslipVariationModal = function(selections, advise, purchaseFunction, amountData) {
			setBetslipVariationModalData({
				selections,
				advise,
				purchaseFunction,
				amountData,
				closeFunction: function() {
					setBetslipVariationModalData(null)
				}
			});
		}
	});

	useEffect(() => {
		setBetslipVariationModalData(null);
        if (!xs_isMobile) {
            if (!toggled) {
                if (coupon.totalDraws === 1) {
                    toggleBetslip();
                }
            } else if (coupon.totalDraws === 0) {
                toggleBetslip();
            }
        }
	}, [coupon.totalDraws]);

    if (xs_isMobile) {
        const coupon = betslipData.coupons[couponKey];
        if (coupon.selections.length === 0) {
            document.body.classList.remove('xs_betslipOpen');
            return null;
        }
    }

	const minimumStake = coupon.selectedContainer === 'systembets'? conf.cs.imqfs : conf.cs.imqf;
	let minimumStakeLabel = null;
	const wagerSelected = betslipContext.betOptionsSelection && betslipContext.betOptionsSelection?.value !== 'REAL'; 
	const stakeMinCheckpointFail = (coupon.selectedContainer === 'systembets' && coupon.amountSystem < minimumStake) || (coupon.selectedContainer !== 'systembets' && coupon.amountMulti < minimumStake);
	if (!wagerSelected && stakeMinCheckpointFail) {
		minimumStakeLabel = `${getLabel('carrello.error.minimum_amount_part1')} [${getCurrencyValue(minimumStake, conf.cs.m, conf.cs.nd, conf.cs.ct)}]`;		
	}
	
	let adviceLabel = minimumStakeLabel;
	if (cartMessage && cartMessage.type !== 'success') {
		adviceLabel = cartMessage.message;
	}

    const showOverlay = !xs_isMobile && betslipContext.getLoaderData().type !== 'hideAll';

    return (
        <div  className={"b_1" + classIf(toggled, 'active')}>
            <div id="betslip-container" className={"b_2" + classIf(showOverlay, 'shadowBetting')} style={getStyle(toggled)}>
                <BetslipBar toggled={toggled} toggleBetslip={toggleBetslip} />
                {toggled &&
                    <>
                        <div className="b_4">
                            <TypeSelector couponKey={couponKey} />
                            <div className="b_4_2">
                                <Img className="b_4_2_1" src="settings_button_betslip.svg" height="24px" width="24px" onClick={toggleSettings} />
                                <Img className="b_4_2_1" src="delete_button_betslip.svg" height="24px" width="24px" onClick={clearBetslip} />
                            </div>
                        </div>
                        {adviceLabel &&
                            <div className="b_5">
                                <Img className="b_5_1" src="icon_error.svg" height="16px" width="16px" />
                                <div className="b_5_2">{adviceLabel}</div>
                            </div>
                        }
                        {coupon.selectedContainer !== 'systembets' && <WageringSection />}
                        <div className="b_20">
                            <div className="b_6">
                                <Coupon couponKey={couponKey} />
                            </div>
                            <div className="b_19">
                                <MultiBonus couponKey={couponKey} />
                                <div className="b_11">
                                    <div onClick={() => {betslipContext.setBetslipMode('BUY')}} className={"b_11_1" + (betslipContext.betslipMode === 'BUY'? ' active' : '')}>
                                        <div className="b_17"></div>
                                        <div className="b_11_1_2">{getLabel('betslip.radio.online', 'Online')}</div>
                                    </div>
                                    <div onClick={() => {betslipContext.setBetslipMode('BOOK_FOR_AGENCY')}} className={"b_11_1" + (betslipContext.betslipMode === 'BOOK_FOR_AGENCY'? ' active' : '')}>
                                        <div className="b_17"></div>
                                        <div className="b_11_1_2">{getLabel('betslip.radio.agency', 'Agency')}</div>
                                    </div>
                                </div>
                                <div className="b_12">
                                    <PotentialWinBox couponKey={couponKey} container={coupon.selectedContainer}>
                                        <AmountBetslipForm couponKey={couponKey} />
                                    </PotentialWinBox>
                                    <Settings couponKey={couponKey} />
                                    {betslipVariationModalData &&
                                        <BetslipVariationModal data={betslipVariationModalData} />
                                    }
                                </div>
                            </div>
                        </div>
                    </>
                }
            </div>
            <BetslipLoaderWrapper element={<BetslipLoader />} />
        </div>
    );
}
